import React from "react"

import InstagramIcon from "../../../../static/images/instagram.png"
import LinkedInIcon from "../../../../static/images/linkedin.svg"

const SiteSocialLinks = ({settings}) => {
  const { instagram, linkedin } = settings || {}

  return (
    <div>
      {instagram && instagram.url ? (
        <a href={instagram.url ? instagram.url : ""} key={instagram.url} target="_blank" rel="nofollow" >
          <img src={InstagramIcon} alt="Instagram" />
        </a>
      ) : null}
      {linkedin && linkedin.url ? (
        <a href={linkedin.url ? linkedin.url : ""} key={linkedin.url} target="_blank" rel="nofollow" >
          <img src={LinkedInIcon} alt="Linked In" />
        </a>
      ) : null}
    </div>
  )
}

export default SiteSocialLinks